import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, HostListener, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import sidebardata from '../sidebar/sidebar-data.json'
import { DarkModeService } from '../dark-mode.service';
import { MyMonitoringService } from '../../services/logging.service';
import { AllRecordsService } from '../../services/allRecordsService';
import { Reports } from '../interfaces/Reports';
import * as XLSX from 'xlsx-js-style';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from '../../services/apiservice';
import { switchMap } from 'rxjs';

interface SidebarSection {
  icon: string;
  label: string;
  disabled?: boolean; // Optional property
  badge?: string; // Optional property
  badgeClass?: string; //optional property
  children?: SidebarSection[]; // Optional property for nested sub-sections
  routerLink?:string;
}

@Component({
  selector: 'app-sidebar2',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, DividerModule, 
    ButtonModule, ToggleSwitchModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  providers: [ConfirmationService, MessageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None

})
export class SidebarComponent {
  isCollapsed = true;
  isMobileView = false;
  @Input() isDarkMode: boolean = false;
  @Input() isSidebarOpen: boolean = false; // Receive the state from parent
  Reports!: Reports[];
  NewReports!: Reports[];
  constructor(private darkModeService: DarkModeService,
    private monotoringService: MyMonitoringService,
    private allRecordsService: AllRecordsService,
    private confirmationService: ConfirmationService, private apiService: ApiService,
    private messageService: MessageService,) {
  }

  sections: SidebarSection[] = sidebardata.sections;
  utilities: SidebarSection[] = sidebardata.utilities;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isMobileView = window.innerWidth < 768;
    //console.log(this.isMobileView); // Debugging
  }

  ngOnInit() {
    this.darkModeService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode = isDarkMode;
    });
    this.toggle();
  }

  toggle() {
    // Toggle the collapsed state
    this.isCollapsed = !this.isCollapsed;
    //console.log('Sidebar is now from SidebarComponent:', this.isCollapsed); // Debug log

    const mainContent = document.querySelector('.main-content');

    if (this.isCollapsed) {
      mainContent?.classList.add('content-collapsed');
      mainContent?.classList.remove('content-expanded');
    } else {
      mainContent?.classList.add('content-expanded');
      mainContent?.classList.remove('content-collapsed');
    }

    // Check if the screen width is 768px or below (mobile view)
    const isMobile = window.innerWidth <= 768;

    // Handle the sidebar visibility with direct style manipulation
    const sidebarElement = document.querySelector('.sidebar-sticky') as HTMLElement;
    if (isMobile) {
      // Toggle the visibility of the sidebar for mobile view
      this.isSidebarOpen = !this.isSidebarOpen;
      this.isCollapsed = false // by default
      // Update sidebar visibility based on the current state
      this.isSidebarOpen ? this.showMobileSidebar(sidebarElement) : this.hideMobileSidebar(sidebarElement);
    }
    else {
      this.showMobileSidebar(sidebarElement)
    }
  }
 
  // Method to show the mobile sidebar
  showMobileSidebar(sidebarElement: HTMLElement) {
    sidebarElement.style.marginTop = '70px';
    sidebarElement.style.position = 'absolute';
    sidebarElement.style.zIndex = '1030';
    sidebarElement.style.width = '250px';
    sidebarElement.style.left = '-10px';  // Show sidebar from the left
    sidebarElement.style.transition = 'all 0.3s ease';
    sidebarElement.style.height = '100%';
  }

  // Method to hide the mobile sidebar
  hideMobileSidebar(sidebarElement: HTMLElement) {
    sidebarElement.style.position = 'absolute';
    sidebarElement.style.zIndex = '1030';
    sidebarElement.style.width = '250px';
    sidebarElement.style.left = '-260px';  // Move sidebar out of view
    sidebarElement.style.transition = 'all 0.3s ease';
    sidebarElement.style.height = '100%';

  }

  collapsedSections: boolean[] = [];

  toggleDropdown(index: number): void {
    this.collapsedSections[index] = !this.collapsedSections[index];
  }

  toggleDarkMode(): void {
    // Toggle dark mode class on the body or root element
    this.darkModeService.toggleDarkMode();
  }
  
  exportToExcel() : void {
    this.apiService.groupId().pipe(
      switchMap(groupId => {
        return this.allRecordsService.getReport(groupId);
      })
    ).subscribe({
      next: (data: any) => {
        this.Reports = data?.Payload;

        const NewReports = this.Reports.map(rec => {
          return {
            'SAP WO': rec.SapWo,
            'TYPE': rec.Type,
            'DATE TAKEN': rec.DateTaken,
            'DISTRICT': rec.District,
            'SCHED DATE': rec.SchedDate,
            'ANALYST STATUS': rec.AnalystStatus,
            'IN SAP': rec.InSap,
            'DISPATCH STATUS': rec.DispatchStatus,
            'TAKEN BY': rec.TakenBy,
            'LAST': rec.Last,
            'FIRST': rec.First,
            'HOUSE': rec.House,
            'STREET': rec.street,
            'City': rec.City,
            'STATE': rec.State,
            'ZIP': rec.Zip,
            'TECH FIRST': rec.TechFirst,
            'TECH LAST': rec.TechLast,
            'TECH ID': rec.TechId,
            'STATUS UPDATE NOTES': rec.StatusUpdateNotes
          }
        });
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(NewReports);
        // generate workbook and add the worksheet
        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, ws, 'Reports');
        // save to file
        XLSX.writeFile(workbook, `Reports.xlsx`);

      }
    });

    
  }
      
}
